import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext({ user: null, refresh: () => {}, logout: () => {}, setUser: () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const refresh = useCallback(() => api("/auth/me").then(setUser).catch(() => setUser(false)), []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = useCallback(() => api("/auth/logout", { method: "POST" }).finally(() => setUser(false)), []);
  return <AuthContext.Provider value={{ user, refresh, logout, setUser }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
